import { createAction } from "redux-actions";
import { GET_ENTITIES_CORE } from "../constants";
import { feathersCreateData } from "../services";

export const getEntitiesCore = createAction(GET_ENTITIES_CORE, (data) => feathersCreateData('core-server', {
    service: 'TRANSFERS',
    func: 'INITIAL LOAD EXTERNAL TRANSFERS'
})())